import { Template } from "../types/Template";
import { BaseService, ResponseData } from "./baseService";

class TemplatesService extends BaseService<Template> {
  controllerName = "template";

  async getFileById(id: number): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();
    const { data } = await this.api.get(`/file/${String(id)}`);
    return data;
  }
}

export const templatesService = new TemplatesService();
